const menuWrapper = document.querySelector(".webx-menu-wrapper");
const hamburgerMenu = document.querySelector(".webx-hamburger-menu");
const menuContent = document.querySelector(".webx-menu-content");

menuWrapper.addEventListener("click", () => {
	hamburgerMenu.classList.toggle("animate");
	menuContent.classList.toggle("open");
});
